import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EnvironmentToken } from '../../../util';
import { Environment } from '../../../typings';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-success-page',
    templateUrl: './success-page.component.html',
    styleUrls: ['./success-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SuccessPageComponent implements OnInit {
  aquentWebsite: string;
  matHost: string;
  source = '';

  constructor(protected route: ActivatedRoute, @Inject(EnvironmentToken) private environment: Environment) {
    this.route.queryParams.subscribe(
      params => {
        this.source = params.source;
      },
      error => {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        console.error(`Error getting lookup fields: ${error}`);
      }
    );
  }

  ngOnInit(): void {
    this.aquentWebsite = this.environment.aquentWebsite;
    this.matHost = this.environment.matHost;
  }
}
